import { render, staticRenderFns } from "./myopiaComplication.vue?vue&type=template&id=23f4eaa6&scoped=true&"
import script from "./myopiaComplication.vue?vue&type=script&lang=js&"
export * from "./myopiaComplication.vue?vue&type=script&lang=js&"
import style0 from "./myopiaComplication.vue?vue&type=style&index=0&id=23f4eaa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4eaa6",
  null
  
)

export default component.exports